var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527 4149 l-67 -72 0 -1119 c0 -1229 -2 -1205 119 -1268 50 -25 174 -30 770 -30 l711 0 0 -150 0 -150 -111 0 c-212 0 -289 -84 -289 -317 0 -176 -52 -163 648 -163 663 0 632 -8 632 165 0 213 -92 315 -283 315 l-117 0 0 150 0 150 350 0 350 0 0 -347 c0 -468 -75 -423 704 -423 l619 0 49 56 48 56 0 1097 c0 1316 32 1186 -300 1201 l-224 10 3 355 c2 295 -3 368 -31 426 -64 136 32 129 -1830 129 l-1683 0 -68 -71z m3464 -57 c36 -26 40 -60 45 -410 l6 -382 -352 0 c-503 0 -482 27 -461 -623 l15 -437 -1342 0 -1342 0 0 903 c0 813 3 908 33 940 45 50 3330 58 3398 9z m564 -1980 c4 -779 -1 -1085 -17 -1105 -27 -32 -1127 -40 -1178 -8 -28 18 -53 2060 -26 2166 8 33 50 35 612 30 l604 -5 5 -1078z m-1319 -160 l5 -192 -1300 0 c-1522 0 -1381 -24 -1381 235 l0 155 1335 -3 1335 -3 6 -192z m-796 -442 l0 -150 -150 0 -150 0 0 150 0 150 150 0 150 0 0 -150z m359 -303 c27 -35 41 -82 41 -140 l0 -87 -540 0 -540 0 0 100 c0 179 3 180 539 180 l458 0 42 -53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3767 3109 c-21 -55 23 -71 185 -65 147 6 158 9 164 51 9 59 -327 72 -349 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3870 1356 c-196 -112 -30 -383 169 -276 58 30 81 122 50 195 -40 97 -132 131 -219 81z m129 -105 c18 -21 18 -39 1 -71 -25 -48 -75 -47 -106 2 -46 74 49 137 105 69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2181 2056 c-137 -146 88 -349 230 -207 60 60 63 128 8 198 -55 70 -178 74 -238 9z m167 -81 c27 -44 -25 -103 -74 -84 -34 13 -47 90 -20 116 22 22 70 6 94 -32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload12);
export default __webpack_public_path__ + "static/media/picsvg_download(12).2d9823f2101279158886c974a99638c7.svg";
export { ForwardRef as ReactComponent };